import { TYPING, TYPING_STOPPED, SELECT_CONVERSATION, LOAD_CONVERSATION, LOAD_CONVERSATIONS } from "../actions/chat";
import { PROFILE_UPDATED } from "../actions";
import { filterUnique } from "../actions/helpers";

export const initialState = {
	activeConversation: null as string,
	myId: null as string,
	typingPartners: [] as string[],
};

export type TypingState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_CONVERSATION: {
			return {
				...state,
				activeConversation: action.conversation.conversationId,
			};
		}

		case LOAD_CONVERSATIONS: {
			const conversations = action.conversations;

			return {
				...state,
				activeConversation: conversations.length > 0 ? conversations[0].conversationId : null,
			};
		}

		case SELECT_CONVERSATION: {
			if (action.id === state.activeConversation) {
				return state;
			}

			return { ...state, activeConversation: action.id };
		}

		case TYPING: {
			const payload = action.payload;

			if (payload.conversationId !== state.activeConversation) {
				return state;
			}

			if (payload.userId === state.myId) {
				return state;
			}

			return {
				...state,
				typingPartners: filterUnique(state.typingPartners.concat(payload.userId)),
			};
		}

		case PROFILE_UPDATED: {
			return {
				...state,
				myId: action.profile.userId,
			};
		}

		case TYPING_STOPPED: {
			const payload = action.payload;
			if (payload.conversationId !== state.activeConversation) {
				return state;
			}

			if (payload.userId === state.myId) {
				return state;
			}

			return {
				...state,
				typingPartners: state.typingPartners.filter((uuid: string) => {
					return uuid !== payload.userId;
				}),
			};
		}

		default:
			return state;
	}
}
